import React, {useState} from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import BgTransformer from "../../../layout/BgTransformer";
import BannerButton from "../../../layout/BannerButton";
import PixelationLayer from "../../../layout/PixelationLayer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import AirBanner, {isAirBanner} from "pages/Releases/AirBanner";
import {PLACEHOLDERS} from "../../../data/constants";

const Email03 = ({id, zoom}) => {
  const {layoutOption, product, channel} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, badges} = useEdits();
  const [isInline, setIsInline] = useState(true);

  const title = titles[id] ?? titles.main;
  const badge = badges[id] ?? badges.main;

  const templateClass = cn("template", product.value, `layout-${layoutOption}`);

  // JetBrains Air replaces the whole banner rather than restyling this one:
  // every channel that lists the product draws the same skin (src/data/offering.ts).
  if (isAirBanner(product.value)) {
    return <AirBanner id={id} zoom={zoom} copy="email" />;
  }

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />
          <PixelationLayer />

          <div className="content">
            <div className="title-wrap">
              <h1 className="title">
                <Textarea id={id} text={title} />
              </h1>
            </div>
            <BannerButton id={id} className="badge">
              <Textarea id={id} text={badge} inline={isInline} />
            </BannerButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default Email03;
